const c = {
  name: "Party",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M21,2.5c0.7,0,1.2-0.6,1.2-1.2C22.3,0.6,21.7,0,21,0c-0.7,0-1.2,0.6-1.2,1.2C19.8,1.9,20.3,2.5,21,2.5z"/>
		<path class="st0" d="M14,7c-1.7,0-3,1.3-3,3c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3C17,8.3,15.7,7,14,7z M13,10c0-0.6,0.4-1,1-1
			s1,0.4,1,1c0,0.6-0.4,1-1,1S13,10.6,13,10z"/>
		<path class="st0" d="M26,7c-1.7,0-3,1.3-3,3c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3C29,8.3,27.7,7,26,7z M25,10c0-0.6,0.4-1,1-1
			s1,0.4,1,1c0,0.6-0.4,1-1,1S25,10.6,25,10z"/>
		<path class="st0" d="M9.3,3c0,0.7-0.6,1.2-1.2,1.2C7.3,4.2,6.8,3.7,6.8,3c0-0.7,0.6-1.2,1.2-1.2C8.7,1.7,9.3,2.3,9.3,3z"/>
		<path class="st0" d="M19,22.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C17.8,21.7,18.3,22.2,19,22.2z"
			/>
		<path class="st0" d="M38,15c0,0.6-0.4,1-1,1c-0.6,0-1-0.4-1-1s0.4-1,1-1C37.6,14,38,14.4,38,15z"/>
		<path class="st0" d="M38.8,33.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2
			C37.5,32.7,38.1,33.2,38.8,33.2z"/>
		<path class="st0" d="M26,3c-3.9,0-7,3.1-7,7c0,2.8-2.2,5-5,5v2c3.9,0,7-3.1,7-7c0-2.8,2.2-5,5-5s5,2.2,5,5h2C33,6.1,29.9,3,26,3z"
			/>
		<path class="st0" d="M25,20c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3c0,1.7-1.3,3-3,3C26.3,23,25,21.7,25,20z M28,19c-0.6,0-1,0.4-1,1
			c0,0.6,0.4,1,1,1s1-0.4,1-1C29,19.4,28.6,19,28,19z"/>
		<path class="st0" d="M31,16.1c2.2,1.7,2.6,4.8,0.9,6.9c-1.7,2.2-4.8,2.6-6.9,0.9l-1.2,1.6c3,2.4,7.4,1.8,9.8-1.2
			c2.4-3,1.8-7.4-1.2-9.8L31,16.1z"/>
		<path class="st0" d="M34,3c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3c0,1.7-1.3,3-3,3C35.3,6,34,4.7,34,3z M37,2c-0.6,0-1,0.4-1,1
			c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1C38,2.4,37.6,2,37,2z"/>
		<path class="st0" d="M23.8,31.4L8.6,16.2L0,40L23.8,31.4z M3.3,36.7l6.1-16.8l10.8,10.8L3.3,36.7z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Party
};
